export default "__VITE_ASSET__OnhN6SDr__"